import Api from "@/repository/ApiBase";
import {CreatePost, CreateTopic, GetPostResponse, UpdatePost, UpdateTopic} from "@/repository/messagehub.dtos";
import {AxiosResponse} from "axios";

export class PostsApi extends Api {
    async getPosts(): Promise<GetPostResponse>{
        let result: AxiosResponse =  await this.Client.get('/topicpost')
        return <GetPostResponse> result.data
    }
    async getPostsInTopic(topicId: string): Promise<GetPostResponse>{
        let result: AxiosResponse =  await this.Client.get('/topicpost/topic?id='+topicId)
        return <GetPostResponse> result.data
    }
    async createPost(post: CreatePost): Promise<AxiosResponse>{
        const json = JSON.stringify(post);
        let result: AxiosResponse = await this.Client.post('/topicpost', json)
        return result
    }
    async updatePost(post: UpdatePost){
        const json = JSON.stringify(post);
        let result: AxiosResponse = await this.Client.put('/topicpost', json)
        return result
    }
    async deletePost(id: string){
        let result: AxiosResponse = await this.Client.delete('/topicpost?id='+id)
        return result
    }
}
